/**
 * SignInModal.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import * as Icons from '../../../sharedComponents/icons/Icons';

import SignInForm from './SignInForm';

const propTypes = {
    disableAccountFeatures: PropTypes.bool,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    create: PropTypes.func,
    reset: PropTypes.func,
    login: PropTypes.func,
    error: PropTypes.bool,
    lockout: PropTypes.bool,
    mfaRequired: PropTypes.bool,
    mfaValidation: PropTypes.bool,
    account: PropTypes.object
};

const defaultProps = {
    disableAccountFeatures: false,
    isOpen: false,
    closeModal: () => {},
    create: () => {},
    reset: () => {},
    login: () => {},
    error: false,
    account: null
};

export default class SignInModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            errorText: null
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.signIn = this.signIn.bind(this);
        this.confirmSignIn = this.confirmSignIn.bind(this);
    }

    componentWillMount() {
        Modal.setAppElement('body');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.account === null && nextProps.account && this.props.isOpen) {
            // Successful login
            this.props.closeModal();
        }

        if (nextProps.error) {
            this.setState({
                errorText: 'Are you sure you have the right email and password? Please double check your email and password, and try again. You can also click the links below to sign up for an account or reset your password.'
            });
        }

        if (nextProps.lockout) {
            this.setState({
                errorText: 'The account has been locked out for 30 minutes due to three or more login attempts. To access your account before then, you can reset your password by clicking on the "Reset Password" link.'
            });
        }
    }

    afterOpenModal() {
        this.setState({
            email: '',
            password: '',
            errorText: null
        });
    }

    signIn() {
        if (this.state.email.length < 1 || this.state.password.length < 1) {
            this.setState({
                errorText: 'All fields are required.'
            });
        }
        else {
            this.setState({
                errorText: null
            });

            const loginData = {
                username: this.state.email,
                password: this.state.password
            };

            this.props.login(loginData);
        }
    }

    confirmSignIn(account) {
        this.setState({
            email: account.email,
            password: account.password,
            errorText: null
        }, () => {
            this.signIn();
        });
    }

    render() {
        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-signin-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Log In"
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <button className="rec-close-modal" onClick={this.props.closeModal}>
                        <Icons.IconClose />
                    </button>
                    <SignInForm
                        disableAccountFeatures={this.props.disableAccountFeatures}
                        errorText={this.state.errorText}
                        create={this.props.create}
                        reset={this.props.reset}
                        confirmSignIn={this.confirmSignIn}
                        mfaValidation={this.props.mfaValidation}
                        mfaRequired={this.props.mfaRequired} />
                </div>
            </Modal>
        );
    }
}

SignInModal.propTypes = propTypes;
SignInModal.defaultProps = defaultProps;
